import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Col, Form, Image, Row, Select, Tag } from "antd";
import { useEffect, useState } from "react";
import { ERcbTier, EUserRole, TRANSLATABLE_CONTENT_BLOCKER_TEMPLATE_ATTRIBUTES_LIST, TemplateMetaDataField, getTemplateHeadline } from "@devowl-wp/api-real-cookie-banner";
import { useTranslation } from "../../../../../../others/i18n.js";
import { service } from "../../../../../../styles/service.js";
import { spacing } from "../../../../../../styles/spacing.js";
import { FormFieldVisibilityWrapper } from "../../formFieldVisibilityWrapper.js";
function FormFieldContentBlockerTemplateExtendsIdentifier({ onChangeExtendedTemplate, hiddenIdentifier = [], templates = undefined }) {
    const { t } = useTranslation();
    // extends template selection
    const [templatesSorted, setTemplatesSorted] = useState();
    useEffect(()=>{
        if (templates) {
            const filtered = templates?.filter((template)=>{
                // filter out extended templates, as they are not allowed
                return !hiddenIdentifier.includes(template.identifier) && !template.extends;
            })?.sort((a, b)=>a?.name.localeCompare(b.name));
            if (templatesSorted?.length !== filtered?.length) {
                setTemplatesSorted(filtered);
            }
        }
    }, [
        templates,
        hiddenIdentifier
    ]);
    return /*#__PURE__*/ _jsx(FormFieldVisibilityWrapper, {
        fieldNames: TemplateMetaDataField.ExtendsIdentifier,
        permissionCheck: {
            whenRole: EUserRole.Translator,
            roleWhiteList: TRANSLATABLE_CONTENT_BLOCKER_TEMPLATE_ATTRIBUTES_LIST
        },
        children: /*#__PURE__*/ _jsx(Form.Item, {
            label: t("Basic template"),
            shouldUpdate: (prev, next)=>{
                if (next && templatesSorted === undefined) {
                    setTemplatesSorted([
                        next
                    ]);
                }
                return prev.extends?.identifier !== next.extends?.identifier || prev.extendsIdentifier !== next.extendsIdentifier;
            },
            extra: t("This template is based on the selected basic template. The information below can be kept, overwritten, extended, or removed as needed."),
            children: ({ getFieldValue })=>{
                const selectedIdentifier = getFieldValue([
                    TemplateMetaDataField.ExtendsIdentifier
                ]);
                const template = templates?.find((template)=>template.identifier === selectedIdentifier);
                return /*#__PURE__*/ _jsxs(Row, {
                    style: {
                        width: "100%",
                        alignItems: "center"
                    },
                    children: [
                        /*#__PURE__*/ _jsx(Col, {
                            hidden: !template?.logo,
                            style: {
                                paddingRight: spacing.layout.content.paddingMedium
                            },
                            children: template?.logo ? /*#__PURE__*/ _jsx(Image, {
                                width: 36,
                                src: template.logo.downloadUrl,
                                alt: template.logo.name,
                                style: {
                                    marginTop: spacing.layout.image.margin,
                                    marginBottom: spacing.layout.image.margin
                                },
                                preview: false
                            }) : null
                        }),
                        /*#__PURE__*/ _jsx(Col, {
                            style: {
                                flex: 1
                            },
                            children: /*#__PURE__*/ _jsx(Form.Item, {
                                name: TemplateMetaDataField.ExtendsIdentifier,
                                shouldUpdate: (prev, next)=>prev.extendsIdentifier !== next.extendsIdentifier,
                                noStyle: true,
                                children: /*#__PURE__*/ _jsx(Select, {
                                    onSelect: (identifier)=>onChangeExtendedTemplate?.(templatesSorted.find((template)=>template.identifier === identifier)),
                                    allowClear: true,
                                    onClear: ()=>onChangeExtendedTemplate?.(undefined),
                                    showSearch: true,
                                    placeholder: t("Select a template"),
                                    optionFilterProp: "label",
                                    options: [
                                        {
                                            label: /*#__PURE__*/ _jsx(Tag, {
                                                color: service.tier.free.color,
                                                children: t("FREE")
                                            }),
                                            options: templatesSorted?.map((template)=>{
                                                if (template.tier === ERcbTier.Free) {
                                                    return {
                                                        value: template.identifier,
                                                        label: getTemplateHeadline(template)
                                                    };
                                                }
                                                return undefined;
                                            }).filter(Boolean) ?? []
                                        },
                                        {
                                            label: /*#__PURE__*/ _jsx(Tag, {
                                                color: service.tier.pro.color,
                                                children: t("PRO")
                                            }),
                                            options: templatesSorted?.map((template)=>{
                                                if (template.tier === ERcbTier.Pro) {
                                                    return {
                                                        value: template.identifier,
                                                        label: getTemplateHeadline(template)
                                                    };
                                                }
                                                return undefined;
                                            }).filter(Boolean) ?? []
                                        }
                                    ].filter((group)=>group.options.length > 0)
                                })
                            })
                        })
                    ]
                });
            }
        })
    });
}
export { FormFieldContentBlockerTemplateExtendsIdentifier };
